import React from 'react';
import styles from '../styles.module.scss';

const Explain = () => {
    return (
        <div className={styles.desc}>
            <div className={styles['desc__desn']}>你想去的目的地</div>
            <div className={styles['desc__name']}>產品名稱</div>
            <div className={styles['desc__days-and-flight']}>旅遊天數、搭乘航空</div>
            <div className={styles['desc__tags']}>遊玩交通、產品規格</div>
            <div className={styles['desc__price']}>行程費用最低價</div>
        </div>
    );
};

export default Explain;
